import dynamic from "next/dynamic"
import { useRouter } from "next/router"
import { ChangeEvent, useMemo } from "react"
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import { useLayoutData } from "../../../../utils/contexts/LayoutContext"
import { FindCheckboxCheckedIconProps } from "../FindDesignTypes"
import { filterUrl } from "../Find"
import { PageType } from "../../../../pages/_app"
import { FilterBaseProps } from "../Find.types"

const FilterCheckBox = ({
  filters,
  pageUrl,
  mmbr,
  colors
}: FilterBaseProps) => {
  const router = useRouter()
  const { partnerSiteFull, templatePath } = useLayoutData()

  const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath

  const FindCheckboxIcon = useMemo(() => dynamic(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindCheckboxIcon)), [path])
  const FindCheckboxCheckedIcon = useMemo(() => dynamic<FindCheckboxCheckedIconProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindCheckboxCheckedIcon)), [path])

  const handleChecked = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      router.push(filterUrl(filters, undefined, filters.targetUrl, pageUrl, mmbr), undefined, { scroll: false })
    } else {
      router.push(filterUrl(filters, undefined, filters.resetUrl, pageUrl, mmbr), undefined, { scroll: false })
    }
  }

  return (
    <Stack>
      <Checkbox
        sx={{ padding: 0 }}
        disableRipple
        checkedIcon={<FindCheckboxCheckedIcon checkedcolor={colors.mainColor} />}
        icon={<FindCheckboxIcon />}
        onChange={handleChecked}
        inputProps={{
          "aria-label": filters?.title
        }}
      />
    </Stack>
  )
}

export default FilterCheckBox